.markdown_inner {

    &[data-ellipsis="true"] {

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    img {
        display: block;
        max-width: 100%;
        height: auto;
    }
}